export default __webpack_public_path__ + "static/background-block-5a284443c23cc40b39995255b861b8d4.png";